import React from "react";
import { useState, useEffect } from "react";
import {
    Modal,
    Fade,
    Box,
    Typography,
    Backdrop,
    TextField,
    Button,
    CircularProgress,
} from "@mui/material";
import { Height } from "@mui/icons-material";
import axios from "axios";
import Cookies from "js-cookie";
import useNotification from "../common/Notification";
import WarningMessage from "../common/WarningMessage";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    height: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: 24,
    borderRadius: 2,
    p: 8,
};

const GroupCreate = ({ opening, closing, open }) => {
    const [backdropOpen, setBackdropOpen] = useState(false);
    // Notification

    const showNotification = useNotification();
    const handleClose = () => {
        opening();
    };

    const [formData, setFormData] = useState({
        name: "",
        file: null,
    });

    const [errors, setErrors] = useState({
        name: false,
        file: false,
    });

    const handleTextChange = (e) => {
        setFormData({ ...formData, name: e.target.value });
        setErrors({ ...errors, name: false });
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFormData({ ...formData, file: selectedFile });
        setErrors({ ...errors, file: false });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const userId = Cookies.get("userId");

        const isNameValid = formData.name.trim() !== "";
        const isFileValid = formData.file !== null;

        if (!isNameValid || !isFileValid) {
            setErrors({
                name: !isNameValid,
                file: !isFileValid,
            });
            return;
        }

        console.log("Submitted Data:", formData);

        const newFormData = new FormData();
        newFormData.append("group_name", formData.name);
        newFormData.append("file", formData.file);
        console.log("formdata file : ", formData.file);
        newFormData.append("user_id", userId);

        try {
            setBackdropOpen(true);
            const res = await axios.post(
                `http://api.virtualprachar.com/api/whatsapp/personal/group/create `,
                newFormData
            );

            showNotification("Group Created Successfully", "success");
            opening(() => false);
            setFormData({
                name: "",
                file: null,
            });
            console.log("response: ", res);
        } catch (e) {
            if (e.status === 400) {
                showNotification(`${e.response?.data?.message}`, "error");
                return;
            }
            if (e.status == 409) {
                showNotification(`${e.response?.data?.message}`, "error");
                return;
            }
            if (e.status === 504) {
                showNotification(`${e.response?.data?.message}`, "error");
                return;
            }

            if (e.status === 413) {
                showNotification(`${e.response?.data.message}`, "error");
                return;
            }
            if (e.status === 422) {
                showNotification(`${e.response?.data.message}`, "error");
                return;
            }
            if (e.status === 200) {
                showNotification(`Phone numbers added in group.`);
                return;
            }
            // showNotification(`${e.message}`, "error");
            // console.log("Error: ", e);
        } finally {
            setBackdropOpen(false);
        }

        // You can upload or parse the file here
    };
    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Box
                            component="form"
                            onSubmit={handleSubmit}
                            sx={{ width: "100%" }}
                        >
                            <WarningMessage />

                            <TextField
                                label="Group Name"
                                fullWidth
                                size="small"
                                variant="outlined"
                                value={formData.name}
                                onChange={handleTextChange}
                                error={errors.name}
                                helperText={
                                    errors.name ? "Name is required" : ""
                                }
                                sx={{ mb: 2 }}
                            />
                            <Box
                                fullWidth
                                sx={{
                                    width: "100%",
                                    height: "auto",
                                    // p: 2,
                                    // border: "1px solid gray",
                                }}
                            >
                                <Button
                                    variant="contained"
                                    component="label"
                                    sx={{ mb: 1 }}
                                >
                                    Choose Excel File
                                    <input
                                        type="file"
                                        hidden
                                        accept=".xls, .xlsx"
                                        onChange={handleFileChange}
                                    />
                                </Button>
                            </Box>

                            {formData.file && (
                                <Typography variant="body2" sx={{ mb: 2 }}>
                                    Selected file: {formData.file.name}
                                </Typography>
                            )}

                            {errors.file && (
                                <Typography
                                    color="error"
                                    variant="body2"
                                    sx={{ mb: 2 }}
                                >
                                    Please select a Excel file
                                </Typography>
                            )}

                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ mt: 2 }}
                                disabled={backdropOpen}
                            >
                                Submit
                                {backdropOpen ? (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            marginTop: "-12px",
                                            marginLeft: "-12px",
                                        }}
                                    />
                                ) : null}
                            </Button>

                            <Typography
                                sx={{
                                    width: "100%",
                                    height: "auto",
                                    fontSize: "12px",
                                    marginTop: 4,
                                }}
                            >
                                <span style={{ fontWeight: "bold" }}>
                                    Note:{" "}
                                </span>
                                Please upload an Excel sheet containing a column
                                with the heading "phone_number". All phone
                                numbers should be listed below this heading in
                                the same column.
                            </Typography>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
};

export default GroupCreate;
